import DocumentDetailsForm from './DocumentDetailsForm'
export { DocumentDetailsForm }
export default DocumentDetailsForm
